export default (url: string, params: string[]): string => {
  if (params.length <= 0) {
    return url;
  }

  const ampersandOrQuestionMark = /\?/.test(url) ? '&' : '?';

  return `${url}${ampersandOrQuestionMark}${params.join('&')}`;
};
